import React from 'react';
import { Badge } from 'react-bootstrap';
import { SquareIcon, PlusSquare, DashSquare, FillSquare, HeartFillIcon } from './Icons';

function IndexPane(props) {
    const [getRefresh, setRefresh] = React.useState(0);
    const [getLevel1State, setLevel1State] = React.useState({});

    const updateLevel1State = (e, item) => {
        let state = getLevel1State;
        state[item] = state[item] ? false : true;
        setLevel1State(state);
        setRefresh(getRefresh + 1);
    }

    const updateLevel2State = (e, selKey, recs) => {
        var fields = selKey.split("|**|");
        props.onChange(selKey, recs, "Show: " + fields[0] + ", " + fields[1] + ", " + fields[2]);
        setRefresh(getRefresh + 1);
    }

    let selParts = props.Selection.split('|**|');

    let items = [];

    let icon0 = getLevel1State["***"] ? DashSquare() : PlusSquare();
    items.push(
        <div key={items.length} onClick={(e) => updateLevel1State(e, "***")}>
            {icon0} {selParts[0] === props.Title ? (<b>{props.Title}</b>) : props.Title}
        </div>
    )
    if (getLevel1State["***"]) {

        let favs = [];
        Object.keys(props.Favorite).forEach((k) => {
            favs.push(Number(k));
        });

        let c1 = {};
        Object.keys(props.Index2Level).forEach((k1) => {
            if (k1 !== "meta") {
                let l1 = props.Index2Level[k1];
                let meta1 = l1.meta;

                c1[k1] = {
                    key: k1,
                    children: [],
                    metaagg: {
                        Fav: 0,
                    },
                    meta: meta1,
                }

                let d1 = c1[k1];

                let c2 = {};
                Object.keys(l1).forEach((k2) => {
                    if (k2 !== "meta") {
                        let l2 = l1[k2];
                        let meta2 = l2.meta;

                        c2[k2] = {
                            key: k2,
                            children: l2,
                            metaagg: {
                                Fav: 0,
                            },
                            meta: meta2,
                        }

                        let d2 = c2[k2];

                        for (let n in l2) {
                            let id = l2[n];

                            if (favs.indexOf(id) !== -1) {
                                d1.metaagg.Fav++;
                                d2.metaagg.Fav++;
                            }
                        }
                    }
                });

                // Level 2 sort order
                d1.children = Object.values(c2)
                    .sort((a, b) => {
                        if (a.meta.FirstTS) {
                            if (a.meta.FirstTS > b.meta.FirstTS) return 1;
                            if (a.meta.FirstTS < b.meta.FirstTS) return -1;
                        }

                        if (a.key > b.key) return 1;
                        if (a.key < b.key) return -1;
                        return 0;
                    });
            }
        });

        // Level 1 sort order
        let display1 = Object.values(c1)
            .sort((a, b) => {
                if (a.meta.FirstTS) {
                    if (a.meta.FirstTS > b.meta.FirstTS) return 1;
                    if (a.meta.FirstTS < b.meta.FirstTS) return -1;
                }

                if (a.key > b.key) return 1;
                if (a.key < b.key) return -1;
                return 0;
            });

        for (let n in display1) {
            let o1 = display1[n];
            let k1 = o1.key;
            let state = getLevel1State;
            let icon = state[k1] ? DashSquare() : PlusSquare();

            let metaicons = [];
            let meta = o1.meta;
            if (meta) {
                Object.keys(meta).forEach((m) => {
                    if (m === "Agent")
                    {
                        metaicons.push(
                            <Badge key={metaicons.length} pill={true} bg="success" className="mr-1">
                                {meta[m]}
                            </Badge>
                        );
                    } else {
                        metaicons.push(
                            <Badge key={metaicons.length} pill={true} bg="info" className="mr-1">
                                {m}:{meta[m]}
                            </Badge>
                        );
                    }
                });
            }

            Object.keys(o1.metaagg).forEach((m) => {
                let n = o1.metaagg[m];
                if (n > 0) {
                    if (m === "Fav") {
                        metaicons.push(
                            <span key={metaicons.length}>
                                <HeartFillIcon />
                                {n}
                            </span>
                        );
                    } else {
                        metaicons.push(
                            <Badge key={metaicons.length} pill={true} bg="info" className="mr-1">
                                {m}:{n}
                            </Badge>
                        );
                    }
                }
            });

            items.push(
                <div key={items.length} className="ml-indent1" onClick={(e) => updateLevel1State(e, k1)}>
                    {icon} {selParts[0] === props.Title && selParts[1] === k1 ? (<b>{k1}</b>) : k1} <small>{metaicons}</small>
                </div>
            );

            if (state[k1]) {
                for (let m in o1.children) {
                    let o2 = o1.children[m];
                    let k2 = o2.key;
                    let key = props.Title + "|**|" + k1 + "|**|" + k2;
                    let icon2 = props.Selection === key ? FillSquare() : SquareIcon();
                    let recs = o2.children;

                    let metaicons2 = [];
                    let meta2 = o2.meta;
                    if (meta2) {
                        Object.keys(meta2).forEach((m) => {
                            metaicons2.push(
                                <Badge key={metaicons2.length} pill={true} bg="info" className="mr-1">
                                    {m}:{meta2[m]}
                                </Badge>
                            );
                        });
                    }

                    Object.keys(o2.metaagg).forEach((m) => {
                        let n = o2.metaagg[m];
                        if (n > 0) {
                            if (m === "Fav") {
                                metaicons2.push(
                                    <span key={metaicons2.length}>
                                        <HeartFillIcon />
                                        {n}
                                    </span>
                                );
                            } else {
                                metaicons2.push(
                                    <Badge key={metaicons2.length} pill={true} bg="info" className="mr-1">
                                        {m}:{n}
                                    </Badge>
                                );
                            }
                        }
                    });

                    items.push(
                        <div key={items.length} className="ml-indent2"
                            onClick={(e) => updateLevel2State(e, key, recs)}>
                            {icon2} {props.Selection === key ? <b>{k2}</b> : k2} {metaicons2}
                        </div>
                    );
                }
            }
        }
    }

    return (
        <div>
            {items}
        </div>
    );
}

export default IndexPane;